define("powergen/controllers/index",
  [],
  function() {
    "use strict";
    var IndexController;

    IndexController = Ember.ObjectController.extend({
      actions: {
        click: function() {
          this.stopVideo();
          this.stopTimer();
          return this.transitionToRoute('setup');
        }
      },
      timer: null,
      startTimer: function() {
        return this.set('timer', Ember.run.later(this, function() {
          return this.playVideo();
        }, 50000));
      },
      stopTimer: function() {
        return Ember.run.cancel(this.get('timer'));
      },
      resetTimer: function() {
        this.stopTimer();
        return this.startTimer();
      },
      showVideo: false,
      playVideo: function() {
        var $video;
        this.stopTimer();
        $video = this.get('view').$('video');
        $video.get(0).currentTime = 0;
        $video.get(0).play();
        $video.on('ended', $.proxy(this.videoEnded, this));
        return this.set('showVideo', true);
      },
      stopVideo: function() {
        var $video;
        $video = this.get('view').$('video');
        $video.get(0).pause();
        return this.set('showVideo', false);
      },
      videoEnded: function() {
        var $video;
        this.startTimer();
        $video = this.get('view').$('video');
        $video.off();
        return this.set('showVideo', false);
      },
      lastScoreWasInTop: true
    });


    return IndexController;
  });